import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  IFireSightBootstrap,
  IFireSightCursorListResponse,
  IFireSightHistoricalIncidentsQuery,
  IFireSightIncidentSummary,
  IFireSightListResponse,
  IFireSightMonitoringArea,
} from '../../interfaces/fire-sight/IFireSightModels';

@Injectable({ providedIn: 'root' })
export class FireSightProjectApiService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = environment.services.urlEDI;

  getBootstrap(projectUuid: string): Observable<IFireSightBootstrap> {
    return this.http.get<IFireSightBootstrap>(
      `${this.apiUrl}/projects/${projectUuid}/fire-sight/bootstrap`,
    );
  }

  getMonitoringAreas(
    projectUuid: string,
  ): Observable<IFireSightListResponse<IFireSightMonitoringArea>> {
    return this.http.get<IFireSightListResponse<IFireSightMonitoringArea>>(
      `${this.apiUrl}/projects/${projectUuid}/fire-sight/monitoring-areas`,
    );
  }

  getHistoricalIncidents(
    projectUuid: string,
    query: IFireSightHistoricalIncidentsQuery,
  ): Observable<IFireSightCursorListResponse<IFireSightIncidentSummary>> {
    let params = new HttpParams().set('limit', query.limit);
    if (query.cursor) {
      params = params.set('cursor', query.cursor);
    }
    if (query.lastObservedFrom) {
      params = params.set('last_observed_from', query.lastObservedFrom);
    }
    if (query.lastObservedTo) {
      params = params.set('last_observed_to', query.lastObservedTo);
    }
    if (query.displayName) {
      params = params.set('display_name', query.displayName);
    }

    return this.http.get<
      IFireSightCursorListResponse<IFireSightIncidentSummary>
    >(`${this.apiUrl}/projects/${projectUuid}/fire-sight/incidents`, {
      params,
    });
  }
}
